import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from "react-router-dom";

const requireAuth = (Component) => {
    const RequireAuthentication = (props) => {
        // Si l'utilisateur n'est pas connecté, redirige vers "/" en mémorisant l'URL demandée
        if (!props.isLoggedIn) {
            return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        }

        // Sinon, rend le composant demandé
        return <Component {...props} />;
    };

    // Map Redux state à props
    const mapStateToProps = (state) => ({
        isLoggedIn: state.authentification.isLoggedIn,
    });

    // Connecte le composant à Redux et ajoute `withRouter` pour accéder à `history`
    return withRouter(connect(mapStateToProps)(RequireAuthentication));
};

export default requireAuth;
